import {Box} from "@mui/material";
import JournalMetrics from "@/src/components/main-site/home/slider/journal-metrics/journal-metrics";
import MainContent from "@/src/components/main-site/home/slider/main-content/main-content";
import ReactHtmlParser from "react-html-parser";

const JournalCard = ({journal}: { journal: any }) => {

    return (
        <Box sx={{
            backgroundColor: (theme) => theme.palette.custom?.homeSliderCardBackground,
            padding: 1,
            borderRadius: '8px',
            height: '100%',
        }}>
            <MainContent
                title={journal.title}
                subtitle={journal.meta_data?.description}
                img={journal.meta_data?.default_cover_image ? process.env.NEXT_PUBLIC_SERVICE_URI_CDN_SERVE + journal.meta_data?.default_cover_image : undefined}
                url={journal.journal_url ?? '#'}
            />
            {journal.meta_data?.overview && (
                <Box
                    sx={{
                        fontSize: '0.8rem',
                        '& a': {
                            textDecoration: 'none',
                        }
                    }}
                >
                    {ReactHtmlParser(journal.meta_data?.overview)}
                </Box>
            )}
            <JournalMetrics journal={journal}/>
        </Box>
    )
};

export default JournalCard;
